import React from 'react';

import css from './Images.module.scss';
import Testimonial from '../../../components/UI/Testimonial/index.tsx';

export const images = {
  secure: (
    <>
      <img
        data-e2e="secure"
        className={css.secure}
        src="/static/secure-fcc.svg"
        alt="Secure"
      />
      <p className={css.secureText}>
        *See Greenlight's Terms of Service for details on earning limits and how
        to qualify. Subject to change at any time. Business bank accounts and
        business debit cards are not permitted.
      </p>
    </>
  ),
  fccSecure: (
    <>
      <img
        data-e2e="secure"
        className={css.secure}
        src="/static/secure-fcc.svg"
        alt="Secure"
      />
      <p className={css.secureText}>
        *Business bank accounts are not permitted.
      </p>
    </>
  ),
  erinTestimonial: (
    <Testimonial
      quote="Greenlight [has] been one of the best decisions we've made. It helps our kids learn savings and interest, as well as it made allowance way easier. Thank you Greenlight."
      author="Erin Carlson"
      location="Prior Lake, MN"
    />
  ),
  jessicaTestimonial: (
    <Testimonial
      quote="It's a wonderful app! It's easy to use and since I never carry cash, it's easy to pay my kids! The learning experience is awesome too!"
      author="Jessica Carpenter"
      location="Otsego, MI"
    />
  ),
  saritaTestimonial: (
    <Testimonial
      quote="Greenlight has been a really convenient and efficient option for us. It has given us many financial teachable moments."
      author="Sarita Howe"
      location="Escondido, CA"
    />
  ),
  trishaTestimonial: (
    <Testimonial
      quote="My teens are 15 and 16 and this is the perfect service for our family. They learn through the app about investing, setting savings goals and rounding up their money... I highly recommend to parents of teens."
      author="Trisha Cofield"
      location="Android GL customer"
      design="max"
    />
  ),
  fccTestimonial: (
    <Testimonial
      quote="It's a great tool for teaching budgeting, taxes, charitable contributions, and more."
      author="— Greenlight parent"
    />
  )
};

const getGroup1Testimonial = maxFlow =>
  maxFlow ? images.trishaTestimonial : images.erinTestimonial;

export const terms = {
  disclosureText: (
    <p className={css.disclosureText}>
      By clicking next, you are accepting Greenlight’s{' '}
      <a target="_blank" href={`https://greenlight.com/terms`} data-e2e="terms">
        Terms of Service
      </a>{' '}
      &{' '}
      <a
        target="_blank"
        href={`https://greenlight.com/privacy`}
        data-e2e="privacy-policy"
      >
        Privacy Statement
      </a>
      .
    </p>
  ),
  disclosureTextWithSmsNotifications: (
    <>
      <p className={css.disclosureText}>
        By clicking next, you are accepting Greenlight’s{' '}
        <a
          target="_blank"
          href={`https://greenlight.com/terms`}
          data-e2e="terms"
        >
          Terms of Service
        </a>{' '}
        &{' '}
        <a
          target="_blank"
          href={`https://greenlight.com/privacy`}
          data-e2e="privacy-policy"
        >
          Privacy Statement
        </a>
        .
      </p>
      <p className={css.disclosureText}>
        *By subscribing to Greenlight text notifications, you agree to receive
        automated promotion and marketing messages from us. This agreement is
        not conditional of purchase. Msg and data rate may apply, Msg frequency
        varies, and Reply STOP to opt out.
      </p>
    </>
  ),
  legalText: (
    <>
      <p className={css.legalText}>
        By selecting “Next,” you acknowledge that the information provided above
        is true and accurate.
      </p>
      <p className={css.legalText}>
        By providing your personal information above, you acknowledge that you
        are sharing your information with Greenlight, our affiliates, and any of
        our financial institution partners who are offering their services
        through Greenlight.
      </p>
      <p className={css.legalText}>
        The Greenlight card is issued by Community Federal Savings Bank,
        pursuant to license by Mastercard International.
      </p>
      <p className={css.legalText}>
        Important information for opening a card account: To help the federal
        government fight the funding of terrorism and money laundering
        activities, the USA PATRIOT Act requires all financial institutions to
        obtain, verify, and record information that identifies each person who
        opens a card account. What this means for you: When you open a card
        account, we will ask for your name, address, date of birth, and other
        information that will allow us to identify you. We may also ask to see
        your driver’s license or other identifying documents.
      </p>
    </>
  ),
  addChildCOPPAText: (
    <p className={css.legalText} data-testid="coppa-disclaimer">
      By providing the information above and clicking next, you verify that you
      are the parent or legal guardian for every child under 13 years old you
      register (shown above) and you consent to Greenlight's{' '}
      <a
        data-testid="terms"
        href={`https://greenlight.com/terms`}
        target="_blank"
      >
        Terms of Service
      </a>{' '}
      and{' '}
      <a
        data-testid="privacy"
        href={`https://greenlight.com/privacy`}
        target="_blank"
      >
        Privacy Statement
      </a>
      .
    </p>
  )
};

const getParentFlows11And15 = (flow, smsNotificationsEnabled, maxFlow) => ({
  group_1: {
    topImage: '',
    terms:
      smsNotificationsEnabled && flow === 'parent_flow_11'
        ? terms.disclosureTextWithSmsNotifications
        : terms.disclosureText,
    bottomImage:
      smsNotificationsEnabled && flow === 'parent_flow_11'
        ? ''
        : getGroup1Testimonial(maxFlow)
  },
  group_2: {
    topImage: '',
    bottomImage: ''
  },
  group_3: {
    topImage: '',
    terms: terms.addChildCOPPAText,
    bottomImage: ''
  },
  group_4: {
    topImage: '',
    bottomImage: ''
  },
  group_5: {
    topImage: '',
    bottomImage: ''
  },
  group_6: {
    topImage: '',
    terms: terms.legalText,
    bottomImage: ''
  },
  group_7: {
    topImage: '',
    bottomImage: images.saritaTestimonial
  },
  group_8: {
    topImage: '',
    bottomImage: images.secure
  }
});

const getPageImages = (smsNotificationsEnabled, maxFlow, fccSecureImage) => ({
  parent_flow_1: {
    group_1: {
      topImage: '',
      terms: smsNotificationsEnabled
        ? terms.disclosureTextWithSmsNotifications
        : terms.disclosureText,
      bottomImage: smsNotificationsEnabled ? '' : images.erinTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: images.jessicaTestimonial
    },
    group_3: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_6: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_5: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  approver_flow_2: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: images.jessicaTestimonial
    }
  },
  parent_flow_6: {
    group_1: {
      topImage: '',
      terms: smsNotificationsEnabled
        ? terms.disclosureTextWithSmsNotifications
        : terms.disclosureText,
      bottomImage: smsNotificationsEnabled ? '' : images.erinTestimonial
    },
    group_2: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_5: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_7: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_3: {
      topImage: '',
      bottomImage: images.secure
    },
    group_4: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    }
  },
  parent_flow_8: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_6: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_9: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_5: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_10: {
    group_1: {
      topImage: '',
      terms: smsNotificationsEnabled
        ? terms.disclosureTextWithSmsNotifications
        : terms.disclosureText,
      bottomImage: smsNotificationsEnabled ? '' : getGroup1Testimonial(maxFlow)
    },
    group_2: {
      topImage: '',
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_6: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_11: getParentFlows11And15(
    'parent_flow_11',
    smsNotificationsEnabled,
    maxFlow
  ),
  parent_flow_12: {
    group_1: {
      topImage: '',
      terms: smsNotificationsEnabled
        ? terms.disclosureTextWithSmsNotifications
        : terms.disclosureText,
      bottomImage: smsNotificationsEnabled ? '' : images.erinTestimonial
    },
    group_2: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_6: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_13: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_6: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_7: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_14: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.erinTestimonial
    },
    group_2: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      bottomImage: images.saritaTestimonial
    },
    group_6: {
      topImage: '',
      bottomImage: images.secure
    }
  },
  parent_flow_15: getParentFlows11And15('parent_flow_15', false, false),
  parent_flow_16: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.fccTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_6: {
      topImage: '',
      bottomImage: ''
    },
    group_7: {
      topImage: '',
      bottomImage: fccSecureImage ? images.fccSecure : images.secure
    }
  },
  parent_flow_17: {
    group_1: {
      topImage: '',
      terms: terms.disclosureText,
      bottomImage: images.fccTestimonial
    },
    group_2: {
      topImage: '',
      bottomImage: ''
    },
    group_3: {
      topImage: '',
      terms: terms.addChildCOPPAText,
      bottomImage: ''
    },
    group_4: {
      topImage: '',
      bottomImage: ''
    },
    group_5: {
      topImage: '',
      bottomImage: ''
    },
    group_6: {
      topImage: '',
      terms: terms.legalText,
      bottomImage: ''
    },
    group_7: {
      topImage: '',
      bottomImage: ''
    },
    group_8: {
      topImage: '',
      bottomImage: fccSecureImage ? images.fccSecure : images.secure
    }
  },
  child_flow_3: {
    group_1: {
      terms: terms.disclosureText
    }
  },
  default_group: {
    topImage: '',
    bottomImage: ''
  }
});

export default getPageImages;
